<template>
  <div v-if="this.displayUI" id="app email-capture">
    <email-capture-header :custom-logo="pageConfig.mastheadLogo" />
    <div class="container email-capture__container" v-if="!pageConfig.whatsNextTextArray">
      <div class="email-capture__masthead-image" v-if="pageInfo.product_image_url">
        <img :src="pageInfo.product_image_url" :alt="pageInfo.product_name" />
      </div>
      <div class="email-capture__content">
        <!-- Masthead -->
        <div class="email-capture__masthead">
          <div class="email-capture__masthead--details">
            <p class="email-capture__masthead--title">
              {{ getLabel("mastheadTitle") }}
            </p>
            <h1 class="text-header-p5">{{ pageInfo.product_name }}</h1>
            <p class="email-capture__masthead--subtitle" v-if="pageConfig.mastheadSubtitle">
              {{ getLabel("mastheadSubtitle") }}
            </p>
          </div>
        </div>

        <!-- Form -->
        <ValidationObserver v-slot="{ handleSubmit }">
          <form class="email-capture__form" @submit.prevent="handleSubmit(submitForm)">
            <ValidationProvider :name="$t('email_capture.email_address')" rules="required|email" v-slot="{ errors }">
              <ms-convo-input id="email" name="email" type="text" :placeholder="$t('email_capture.email_address')"
                :is-required="true" :is-error="!!errors[0]" :label="getLabel('emailSubscriptionLabel')" :helpText="pageConfig.emailSubscriptionHelptext
      ? getLabel('emailSubscriptionHelptext')
      : ''
    " :errorText="errors[0]" v-model="form.email" />
            </ValidationProvider>

            <ms-checkbox id="consent" label="" reverse hide-border>
              <ms-checkbox-item id="marketingConsent" name="marketingConsent"
                :label="$t('email_capture.marketing_consent')" :value="marketingConsent" v-model="form.consent" />
              <template v-for="({ value, label }, index) in pageConfig.userConsents">
                <ms-checkbox-item v-if="value !== marketingConsent" :key="index" :id="value" :label="label[$locale]"
                  :name="value" :value="value" v-model="form.consent" />
              </template>
            </ms-checkbox>

            <ms-button type="submit" class="mt-4" :label="pageConfig.ctaText ? getLabel('ctaText') : ''"
              :icon="['far', 'arrow-right']" position="end">
              {{
    pageConfig.ctaLabel
      ? getLabel("ctaLabel")
      : $t("email_capture.next")
  }}
            </ms-button>
            <p class="email-capture__tc mt-1" v-html="$t(
      `email_capture.${regionCode}_terms_and_privacy`,
      termsAndPrivacyUrls
    )
    "></p>
            <ms-link v-if="showSkipLink" @click="skipForm()" class="email-capture__skip">{{ $t("email_capture.skip")
              }}</ms-link>
          </form>
        </ValidationObserver>

        <!-- Contents -->
        <template v-if="pageConfig.paragraphs">
          <div class="email-capture__contents" v-for="(item, index) in pageConfig.paragraphs" :key="index">
            <h4 class="email-capture__contents--title" v-if="item.title">
              {{ item.title[$locale] }}
            </h4>
            <p class="email-capture__contents--text pb-3" v-if="item.text">
              {{ item.text[$locale] }}
            </p>

            <ms-list-group v-if="item.list" :type="item.list.style">
              <ms-list-group-item v-for="(listItem, listItemIndex) in item.list.values" :key="listItemIndex">
                {{ listItem[$locale] }}
              </ms-list-group-item>
            </ms-list-group>
          </div>
        </template>

        <!-- Terms -->
        <div class="email-capture__terms" v-if="termsAndConditionsExists">
          <ms-link :href="pageConfig.promotion_tnc_link[$locale]">
            {{ $t("email_capture.terms_and_condition") }}
            <ms-icon :icon="['fal', 'long-arrow-right']"></ms-icon>
          </ms-link>
        </div>
      </div>
    </div>

    <!-- New email capture layout -->

    <div class="container new-email-capture__container" v-else>
      <div class="new-email-capture__breadcrumb">
        <div class="breadcrumb__item breadcrumb-active">
          {{ $t("email_capture.enter_email") }}
        </div>
        <div class="breadcrumb__icon">
          <ms-icon :icon="['fas', 'caret-right']"></ms-icon>
        </div>
        <div class="breadcrumb__item">
          {{ `${$t("email_capture.apply_for")} ${$t(`email_capture.breadcrumbs.${pageInfo.channel_slug}`)}` }}
        </div>
        <div class="breadcrumb__icon">
          <ms-icon :icon="['fas', 'caret-right']"></ms-icon>
        </div>
        <div class="breadcrumb__item">
          {{ $t("email_capture.redeem_your_gift") }}
        </div>
      </div>
      <div class="new-email-capture__content">
        <!-- Masthead -->
        <div class="email-capture__masthead">
          <div class="email-capture__masthead--details">
            <p class="email-capture__masthead--title">
              {{ $t("email_capture.masthead_title") }}
            </p>
            <h1 class="text-header-p5">{{ pageInfo.product_name }}</h1>
          </div>
          <div class="email-capture__masthead--image" v-if="pageInfo.product_image_url">
            <img :src="pageInfo.product_image_url" :alt="pageInfo.product_name" />
          </div>
        </div>

        <!-- Promotion Snippet -->
        <ms-promotion-snippet v-if="pageInfo.campaign_snippet_text" :use="pageInfo.campaign_theme_color"
          :image="pageInfo.campaign_image">
          <div v-html="pageInfo.campaign_snippet_text"></div>
        </ms-promotion-snippet>

        <!-- Form -->
        <p class="claim-form__text">{{ $t("email_capture.email_notice") }}</p>

        <ValidationObserver v-slot="{ handleSubmit }">
          <a href="#" @click.prevent="redirectToGoogleOAuthCallout()" class="social-btn--google">
            <img src="https://assets.cdn-moneysmart.com/assets/google.svg" />
            <span>{{ $t("email_capture.google_signup") }}</span>
          </a>

          <div class="or-separator">
            <span>{{ $t("email_capture.or_separator") }}</span>
          </div>

          <form class="email-capture__form" @submit.prevent="handleSubmit(submitForm)">
            <ValidationProvider rules="required|email" v-slot="{ errors }">
              <ms-convo-input id="email" name="email" type="text" :placeholder="$t('email_capture.email_address')"
                :is-required="true" :is-error="!!errors[0]" label="" helpText="" :errorText="errors[0]"
                v-model="form.email" />
            </ValidationProvider>

            <ms-checkbox id="consent" label="" reverse hide-border>
              <ms-checkbox-item id="marketingConsent" name="marketingConsent"
                :label="$t('email_capture.marketing_consent')" :value="marketingConsent" v-model="form.consent" />
            </ms-checkbox>

            <ms-button type="submit" class="submit-btn" :icon="['far', 'arrow-right']" position="end">
              {{ $t("email_capture.email_continue") }}
            </ms-button>
          </form>

          <p class="claim-form__disclaimer" v-html="$t(
    `email_capture.${regionCode}_terms_and_privacy`,
    termsAndPrivacyUrls
  )
    "></p>

          <div class="or-separator"></div>

          <p class="claim-form__title">
            {{ $t("email_capture.claim_form_info_title") }}
          </p>
          <p class="claim-form__subtitle spacing">
            {{ $t("email_capture.claim_form_info_subtitle") }}
          </p>
          <p class="claim-form__title spacing">
            {{ $t("email_capture.claim_form_whats_next_title") }}
          </p>

          <!-- If new whats next configuration is present use it, otherwise use default -->
          <ol class="ol" v-if="pageConfig.whatsNextTextArray">
            <li
              class="claim-form__subtitle"
              v-for="(value, key) in pageConfig.whatsNextTextArray"
              :key="key"
              v-html="value[$locale]"
            >
            </li>
          </ol>
          <ol class="ol" v-else>
            <li
              class="claim-form__subtitle"
              v-for="(value, key) in $t(
                'email_capture.claim_form_whats_next_subtitle'
  )" :key="key" v-html="value">
            </li>
          </ol>

          <!-- Custom Html from Config-->
          <div v-html="pageConfig.customHtml[$locale]" v-if="pageConfig.customHtml"></div>

        </ValidationObserver>
      </div>
    </div>

    <email-capture-footer />
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import msAuth from "@moneysmart/auth";
import axios from "axios";
import analyticsTrackerMixin from "../../mixins/analytics-tracker";

const marketingConsent = "marketing/all_offers";
const consentSource = 'iecp';

export default {
  mixins: [analyticsTrackerMixin],
  props: [
    "pageInfo",
    "pageConfig",
    "trackingEvent",
    "pageViewEvent",
    "trackingData",
    "emailCaptureAnalyticsData",
    "emailCapturePageViewData",
    "emailTriggerPath",
    "redirectionUrl",
    "iecpEnableSkip",
    "consentTag",
    "regionCode",
    "campaignId",
    "isPostRequest",
  ],
  methods: {
    getLabel(type) {
      return this.pageConfig?.[type]?.[this.$locale];
    },
    currentUser() {
      return msAuth
        .currentSession()
        .then((res) => res.tokens.idToken.payload).catch(() => ({}));
    },
    redirectToRedirectionUrl() {
      if (this.isPostRequest) {
        submitAsPost(this.redirectionUrl);
      } else {
        window.location.replace(this.redirectionUrl);
      }
    },
    googleSignUpButtonTracking() {
      const data = {
        ...this.emailCaptureAnalyticsData,
        loginMethod: "google",
        additionalParameters: {
          callback_url: sessionStorage.getItem("callback_url"),
        },
      };

      this.fireTrackingEvent("UserAuth.LoggedIn", data);
    },
    async redirectToGoogleOAuthCallout() {
      const callbackUrl = new URL(window.location.href);
      sessionStorage.setItem("callback_url", callbackUrl.href);

      this.googleSignUpButtonTracking();

      try {
        await msAuth.signOut();
        msAuth.federatedSignIn({ provider: "Google" });
      } catch (error) {
        if (this.$airbrake) {
          this.$airbrake.notify(error);
        }
      }
    },
    currentUserMarketingConsent() {
      return msAuth.getAuthenticationHeaders().then((tokens) => {
        return msAuth
          .currentUserConsents(tokens)
          .then((res) => {
            return res.find((consent) => {
              return consent.attributes.consent_type === this.marketingConsent;
            });
          })
          .catch(() => undefined);
      });
    },
    setCsrfHeader() {
      return {
        "X-CSRF-Token": document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content")
      }
    },
    postConsentHeader() {
      return { MS_UDS_TOKEN: process.env.USER_DATA_SERVICE_TOKEN };
    },
    sendRequests() {
      axios.post(
        `${process.env.MS_API_ENDPOINT}/uds/v2/consents`,
        this.consentParams,
        { headers: this.postConsentHeader() }
      )
        .then((consentResponse) => {
          if (consentResponse.status === 200) {
            this.uuid = consentResponse.data?.data[0]?.attributes.user_uuid;
            if(this.uuid) this.form.uuid = this.uuid;
            return this.triggerEmail(this.form)
          }
        })
        .then((emailResponse) => {
          if (emailResponse.status === 200) this.redirectToRedirectionUrl()
        })
        .catch((err) => err);
    },
    triggerEmail(params = {}) {
      params["campaign_id"] = this.campaignId;
      return axios.post(this.emailTriggerPath, params, { headers: this.setCsrfHeader() }).catch((err) => err);
    },
    submitForm() {
      let marketingConsentObj = this.consentParams.consent_attributes.find(
        (consent) => consent.consent_type === marketingConsent
      );

      if (!marketingConsentObj) {
        marketingConsentObj = {
          consent_type: marketingConsent,
          consent_source: consentSource,
          status: 'DENIED',
          locale: this.$locale
        };
        this.consentParams.consent_attributes.push(marketingConsentObj);
      }

      const data = {
        ...this.emailCaptureAnalyticsData,
        leadId: null,
        marketingConsent: marketingConsentObj?.status,
      };

      Promise.all([
        this.fireTrackingEvent("LeadGeneration.FormSubmitted", data),
        this.fireTrackingEvent(this.trackingEvent, Object.assign(this.trackingData, { formEmail: this.form.email })),
      ]).then(() => this.sendRequests());
    },
    skipForm() {
      const data = {
        ...this.emailCaptureAnalyticsData,
        eventType: "skip-reward",
      };
      Promise.all([
        this.fireTrackingEvent("UserEngagement.ButtonClick", data),
        this.fireTrackingEvent(this.trackingEvent, this.trackingData),
      ]).then(() => this.redirectToRedirectionUrl());
    },
  },
  data() {
    return {
      form: {
        email: "",
        consent: [],
      },
      marketingConsent,
      displayUI: true,
    };
  },
  created() {
    this.currentUser().then(async ({ email, "custom:uuid": uuid }) => {
      if (email) {
        this.displayUI = false;
        this.currentUserMarketingConsent()
          .then((previousConsent) => {
            if (previousConsent) {
              const consentParams = {
                email,
                custom_tag: this.consentTag,
                consent_attributes: [
                  {
                    consent_type: this.marketingConsent,
                    consent_source: consentSource,
                    status: previousConsent?.attributes?.status,
                  },
                ],
              };

              axios.post(
                `${process.env.MS_API_ENDPOINT}/uds/v2/consents`,
                consentParams,
                { headers: this.postConsentHeader() }
              );
            }

            return previousConsent;
          })
          .then((marketingConsentObj) => {
            this.fireTrackingEvent('LeadGeneration.FormSubmitted', {
              ...this.emailCaptureAnalyticsData,
              leadId: null,
              marketingConsent: marketingConsentObj?.attributes?.status,
            });

            this.fireTrackingEvent(this.trackingEvent, this.trackingData).then(
              () => {
                this.triggerEmail({ email, uuid }).then((res) => {
                  if (res && res.status === 200) {
                    this.redirectToRedirectionUrl();
                  }
                });
              }
            );
          });
      } else {
        this.fireTrackingEvent(
          this.pageViewEvent,
          this.emailCapturePageViewData
        );
      }
    });

    this.form.consent = [marketingConsent];
  },
  components: {
    ValidationObserver,
    ValidationProvider,
    EmailCaptureHeader: () =>
      import("../header" /* webpackChunkName: 'EmailCaptureHeader' */),
    EmailCaptureFooter: () =>
      import("../footer" /* webpackChunkName: 'EmailCaptureFooter' */),
  },
  computed: {
    termsAndPrivacyUrls() {
      return {
        terms_url: `https://www.moneysmart.${process.env.REGION_CODE}/terms-of-use`,
        privacy_url: `https://www.moneysmart.${process.env.REGION_CODE}/privacy-policy`,
      };
    },
    consentParams() {
      const { email, consent } = this.form;
      const consent_attributes = consent.map((value) => {
        return {
          consent_type: value,
          consent_source: consentSource,
          status: "GRANTED",
          locale: this.$locale
        };
      });

      return {
        email,
        custom_tag: this.consentTag,
        consent_attributes,
      };
    },
    termsAndConditionsExists() {
      const { promotion_tnc_title, promotion_tnc_link } = this.pageConfig;
      return promotion_tnc_title && promotion_tnc_link;
    },
    showSkipLink() {
      return this.iecpEnableSkip === "true";
    },
  },
};
</script>

<style lang="scss">
$force: !important;

.email-capture {
  &__container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;

    @include respond-to(tablethd) {
      flex-direction: row;
    }
  }

  &__content {
    width: 100%;
    max-width: 698px;
    order: 2;

    @include respond-to(phablet) {
      order: 1;
    }
  }

  &__masthead {
    padding: $c-space-inset-xs 0 $c-space-inset-l;

    @include respond-to(phablet) {
      padding: $l-space-inset-default 0;
      flex-direction: row;
    }

    &--title {
      font-size: 10px;
      font-weight: $fw-medium;
      text-transform: uppercase;
      padding-bottom: $c-space-inset-s;

      @include respond-to(phablet) {
        padding-bottom: 0;
      }
    }

    &--subtitle {
      margin-top: $c-space-inset-xs;
      font-size: 16px;
    }

    h1 {
      font-size: $text-header-mobile-p3;
      line-height: 30px;

      @include respond-to(phablet) {
        font-size: $text-header-mobile-p5;
        line-height: 50px;
      }
    }
  }

  &__masthead-image {
    order: 1;
    padding-left: 0px;
    padding-top: $c-space-inset-l;

    @include respond-to(tablethd) {
      padding: $l-space-inset-default 0 $l-space-inset-default $l-space-inset-xl;
      order: 2;
    }

    img {
      height: 75px;

      @include respond-to(phablet) {
        height: 138px;
      }
    }
  }

  &__form {
    border: 1px solid $color-dark-line-grey;
    padding: $c-space-inset-m;
    margin-bottom: $l-space-inset-s;
    border-radius: 3px;

    @include respond-to(phablet) {
      padding: $c-space-inset-xl;
    }

    .error {
      font-size: $text-body-m2;
      color: $color-interactive-red;
    }

    .btn {
      min-width: 192px;
    }
  }

  &__skip {
    display: block;
    font-size: $text-body-m2;
    padding: $c-space-inset-xl 0 0;
  }

  &__tc {
    margin-top: $l-space-inset-xs;
    font-size: $text-body-m2;

    @include respond-to(phablet) {
      margin-top: 0;
    }
  }

  &__label {
    font-size: $text-body-m2;
  }

  &__terms {
    font-size: $text-body-m2;
    padding: $l-space-inset-xl 0 $c-space-inset-xl;

    svg {
      margin-left: $c-space-inset-xs;
    }
  }
}

.new-email-capture {
  &__container {
    max-width: 600px;
    margin-top: $c-space-24;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }

  &__breadcrumb {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: $text-body-m1;
    font-weight: $fw-light;
    line-height: 20px;
    color: $color-neutral-50;

    .breadcrumb__icon {
      margin: 0 $c-space-16;
    }

    .breadcrumb-active {
      font-size: 16px $force;
      font-weight: $fw-semibold;
      line-height: 26px;
      color: $color-neutral-60;
    }
  }

  &__content {
    .email-capture__masthead {
      margin-top: $c-space-16;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 0;

      &--title {
        font-size: $text-body-m3;
        font-weight: $fw-medium;
        line-height: 14px;
        letter-spacing: 0.25px;
        color: $color-neutral-50;
        padding-bottom: 0;
      }

      h1 {
        font-size: $text-header-mobile-p2;
        font-weight: $fw-semibold;
        line-height: 28px;
        letter-spacing: -0.1px;
        color: $color-neutral-60;

        @include respond-to(tablethd) {
          font-size: $text-header-desktop-p2;
          line-height: 29px;
        }
      }

      &--image {
        max-width: 80px;
      }
    }

    .promotion-snippet {
      margin-top: $c-space-16;

      &__content {
        line-height: 18px;
        font-size: $text-body-m1 $force;
      }
    }

    .submit-btn {
      margin-top: $c-space-16;
      min-width: 192px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 48px;
      border-radius: 2px;
    }

    .social-btn--google {
      margin-top: 16px;
      display: flex;
      align-items: center;
      width: 100%;
      height: 48px;
      border-radius: 2px;
      background: #4285f4;
      cursor: pointer;

      img {
        margin-left: $c-space-4;
      }

      span {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        color: $color-neutral-00;
        font-size: $text-header-mobile-p1;
        font-style: normal;
        font-weight: $fw-regular;
        line-height: 18px;
        cursor: pointer;
      }
    }

    .or-separator {
      margin: $c-space-24 0;
      width: 100%;
      text-align: center;
      border-bottom: 1px solid $color-neutral-30;
      line-height: 0.1em;

      span {
        background: $color-neutral-00;
        padding: 0 $c-space-8;
        text-transform: uppercase;
        font-size: $text-body-0;
        font-weight: $fw-semibold;
        color: $color-neutral-50;
      }
    }

    .email-capture__form {
      padding: 0;
      border: 0;
      margin-top: $c-space-16;
      margin-bottom: 0;

      .convo-input {
        .label_wrapper {
          padding: 0;
        }
      }

      .required-field {
        display: none $force;
      }
    }

    .claim-form {
      &__title {
        margin-top: $c-space-16;
        font-size: $text-body-p1;
        font-weight: $fw-semibold;
        line-height: 26px;

        &.spacing {
          margin-top: $c-space-8;
        }
      }

      &__subtitle {
        font-size: $text-body-m1;
        font-weight: $fw-light;
        line-height: 26px;

        &.spacing {
          margin-top: $c-space-8;
        }
      }

      &__text {
        font-size: $text-body-m1;
        font-weight: $fw-light;
        line-height: 20px;
      }

      &__disclaimer {
        color: $color-neutral-50;
        margin-top: $c-space-16;
        font-size: $text-body-m2;
      }
    }
  }
}

ol {
  margin-top: $c-space-8;
  margin-left: $c-space-12;
}

// Cargo overwrites
.input-group__items {
  &.has-no-border.is-reverse .input-group__item label {
    font-weight: $fw-light;
    font-size: $text-body-m1 $force;
    padding-top: 0 $force;
  }
}

.input-group__item {
  &.checkbox {
    padding: $c-space-inset-m 0 0;
  }

  label {
    min-height: unset;
  }

  &-wrap {
    flex-basis: 20px $force;
    height: 20px $force;
    min-width: 20px $force;
  }
}
</style>
